<template>
  <div>
    <section class="banner-ajuda parallax-window" data-parallax="scroll">
      <div class="container text-center">
        <h1>Ajuda</h1>
      </div>
    </section>
    <section class="ajuda container">
      <div class="row">
        <div class="col-12 col-md-3 mb-3">
          <div class="box-categorias sticky-top">
            <div class="nav flex-column nav-pills" id="categorias-ajuda-tab" role="tablist" aria-orientation="vertical">
              <router-link class="nav-link active" :to="{ name: 'faq' }" active-class="active">FAQ</router-link>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-9">
          <div class="box-ajuda">
            <div class="tab-content" id="v-pills-tabContent">
              <transition name="slide-fade" mode="out-in">
                <router-view></router-view>
              </transition>
            </div>
          </div>
        </div>
      </div>
    </section>

    <voll-chat />
  </div>
</template>

<script>
import $ from 'jquery'
import 'jquery-parallax.js'
import VollChat from '@/core/components/chat/VollChat'

export default {
  name: 'AjudaView',
  components: { VollChat },
  created () {
    setTimeout(function () {
      $('.parallax-window').parallax({ imageSrc: require('@/assets/img/bannerajuda.jpg') })
    }, 100)
  },
  beforeDestroy () {
    $('.parallax-mirror').remove()
  }
}
</script>

<style scoped>

</style>
